import React, { Component } from 'react';
import bugsnagClient from './bugsnagClient';

const ErrorBoundary = bugsnagClient.getPlugin('react');

export default class BugsnagInit extends Component {
  render() {
    const { children } = this.props;
    if (process.env.MY_ENV !== 'production') {
      return children;
    }

    return <ErrorBoundary>{children}</ErrorBoundary>;
  }
}
